<template>
  <div class="animated fadeIn">
    <loader v-if="loading"></loader>
    <div v-if="!loading">
      <component-header
        title="Commission Rule"
        :isLoading="isloading"
        @reload-data="reloadData"
        @create-press="$router.push({ path: 'commission/create' })"
        :hasback="false"
        @search-query="(val) => (filter = val)"
      />
      <b-card class="card-wrap" border-variant="info">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive
            :items="commissionRuleList"
            :fields="commissionRuleColumns"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            class="mt-3 tableRadius"
            :filter="filter"
            show-empty
          >
            <template slot-scope="data" slot="commission.rate">
              {{ (data.item.commission.rate * 100).toFixed(2) }}%
            </template>
            <template slot-scope="data" slot="action">
              <b-button
                v-if="data.item.active"
                @click="editRule(data.item)"
                size="sm"
                class="mr-2 butto-circle"
                variant="primary"
              >
                <i class="fas fa-pencil-alt"></i>
              </b-button>
              <b-button
                v-if="data.item.active"
                @click="deleteRule(data.item)"
                size="sm"
                class="mr-2 butto-circle"
                variant="danger"
              >
                <i class="fas fa-trash-alt"></i>
              </b-button>
            </template>
            <template slot="empty">
              <div v-if="isloading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div class="float-right">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="commissionRuleList.length"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentHeader";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  name: "CommissionRuleList",
  data() {
    return {
      filter: "",
      loading: false,
      isloading: false,
      currentPage: 1,
      perPage: 8,
      commissionRuleColumns: [
        {
          key: "ruleName",
        },
        {
          key: "ruleType",
        },
        {
          key: "commission.applicableTo",
        },
        {
          key: "commission.appliedOn",
        },
        {
          key: "commission.rate",
        },
        {
          key: "action",
        },
      ],
    };
  },
  components: {
    ebButton,
    ComponentHeader,
    loader,
  },
  computed: {
    ...mapGetters({
      getFetchCommissionRule: "commission/GetFetchCommissionRule",
    }),
    commissionRuleList() {
      return this.getFetchCommissionRule.filter((x) => x.active);
    },
  },
  methods: {
    editRule(data) {
      this.$router.push({
        name: "CommissionSetupEdit",
        params: {
          id: data._id,
        },
      });
    },
    async reloadData() {
      this.isloading = true;
      await this.$store.dispatch("commission/fetchCommissionRuleAction");
      this.isloading = false;
    },
    async deleteRule(data) {
      this.$swal({
        title: "Delete this Commission Rule?",
        text: "Are you sure?This will be Remove?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.isloading = true;
          this.$store
            .dispatch("commission/deleteCommissionRuleAction", data._id)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Commission Rule Deleted Successfully!",
                type: "success",
              });
            });
          this.isloading = false;
        }
      });
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("commission/fetchCommissionRuleAction");
    this.loading = false;
  },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
